import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { removeSeasons } from '../../../modules/seasons/actions';
import { IconButton, Menu } from '@mui/material';
import MoreVert from '@mui/icons-material/MoreVert';
import RemoveDocumentsMenuItem from 'shared/_model/docs/components/RemoveDocumentsMenuItem';
import useMenu from 'shared/hooks/use-menu';


export default function SeasonActionMenu({ item, removeCallback }) {
  const dispatch = useDispatch();
  const removeAction = useCallback(async (ids, cb) => {
    return await dispatch(removeSeasons(ids, cb));
  }, []);

  const { anchorEl, open, handleOpen, handleClose } = useMenu();

  return (
    <>
      <IconButton onClick={handleOpen} size="small">
        <MoreVert fontSize="small"/>
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <RemoveDocumentsMenuItem docs={[item]} action={removeAction} actionCallback={removeCallback} callback={handleClose} />
      </Menu>
    </>
  );
}

SeasonActionMenu.propTypes = {
    item: PropTypes.shape({}),
    removeCallback: PropTypes.func,
};
